import { IDialogState } from './SummaryFeedbackConfigurationMatchItem.interfaces';

const INITIAL_DIALOG_STATE = Object.freeze<IDialogState>({
  isVisible: false,
  title: '',
});

export { INITIAL_DIALOG_STATE };
